import { useEffect } from 'react';

import { isExternalSourceError } from '@shared/utils-frontend/is-external-source-error';
import logger from '@shared/utils-frontend/logger';

export const useErrorHandling = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (isExternalSourceError(event.filename)) {
        logger.warn(`Uncaught external error: ${event.message}`, {
          filename: event.filename,
          lineNumber: `${event.lineno}`,
          columnNumber: `${event.colno}`,
        });
        return;
      }
      logger.error(
        `Uncaught error: ${event.message}`,
        {
          filename: event.filename,
          lineNumber: `${event.lineno}`,
          columnNumber: `${event.colno}`,
        },
        event.error,
      );
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);
};
